import PlainBadge, { type PlainBadgeProps } from './plain-badge'
import PlainBadgesGroup, { type PlainBadgesGroupProps } from './plain-badges-group'


export default PlainBadge
export { PlainBadgesGroup }
export type { PlainBadgeProps, PlainBadgesGroupProps }
